/* Modèle unique de fiche produit (snippets/printtex-fiche.liquid) : couleur avant taille, nombre de couleurs,
   repli des grands nuanciers, onglet « Acheter sans personnalisation », date de livraison dans les points clés. */
(() => {
  var ptxT = window.ptxT || (window.ptxT = (s) => (window.PTX_T && window.PTX_T[s]) || s); // traductions du site (lot 31)
  const fmt = (s, v) => ptxT(s).replace(/\{(\w+)\}/g, (_, k) => v[k]);
  const MAX = 12; // pastilles visibles avant « Voir les N couleurs »

  function couleurs() {
    document.querySelectorAll('.variant-picker').forEach((picker) => {
      const champs = [...picker.querySelectorAll('fieldset')];
      const couleur = champs.find((f) => /couleur|color|coloris/i.test(f.querySelector('legend')?.textContent || ''));
      if (!couleur || couleur.dataset.pf) return;
      couleur.dataset.pf = '1';
      couleur.style.order = '-1'; // couleur toujours avant la taille
      const pastilles = [...couleur.querySelectorAll('.swatches > li, .swatches > *')].filter((li) => li.querySelector('input'));
      const n = pastilles.length;
      pastilles.forEach((li) => { const v = li.querySelector('input')?.value; if (v) li.title = v; }); // nom au survol
      const nom = couleur.querySelector('.form__label .font-medium');
      if (nom && n > 1) nom.insertAdjacentHTML('afterend', `<span class="pf-nb-couleurs">· ${n} couleurs</span>`);
      if (n <= MAX + 2) return;
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pf-plus-couleurs';
      let ouvert = false;
      const maj = () => {
        pastilles.forEach((li, i) => li.classList.toggle('pf-swatch-cachee', !ouvert && i >= MAX && !li.querySelector('input:checked')));
        btn.textContent = ouvert ? ptxT('Moins de couleurs') : fmt('Voir les {n} couleurs', { n });
      };
      btn.addEventListener('click', () => { ouvert = !ouvert; maj(); });
      couleur.querySelector('.swatches')?.after(btn);
      couleur.addEventListener('change', maj);
      maj();
    });
  }

  function vierge() {
    const onglet = document.querySelector('[data-pf-vierge-onglet]');
    if (!onglet) return;
    const ouvrir = () => document.body.classList.toggle('pf-vierge-ouvert', onglet.open);
    onglet.addEventListener('toggle', ouvrir);
    // Ancien lien « Acheter vierge » (#pp-vierge) : ouvre l'onglet.
    if (location.hash === '#pp-vierge') { onglet.open = true; onglet.scrollIntoView({ block: 'center' }); }
    ouvrir();
  }

  // Date estimée calculée par printtex-perso.js (jours ouvrés, fériés exclus), reprise dans les points clés.
  function livraison() {
    const src = document.querySelector('[data-pp-livraison]');
    const dst = document.querySelector('[data-pf-livraison]');
    if (src && dst && /entre le/.test(src.textContent)) dst.innerHTML = src.innerHTML;
  }

  // Prix du haut = celui de la grille de la couleur choisie (remplie par printtex-perso.js), pour ne jamais afficher deux prix différents.
  function prixHaut() {
    // La grille de l'outil (remplie par printtex-perso.js) fait foi : si elle est sur la page, le prix du haut vient d'elle,
    // même si le produit manque dans snippets/printtex-perso-prix.liquid (sinon on affichait le prix du vêtement nu).
    const grille = document.querySelector('[data-pp-grille]');
    const bloc = document.querySelector('.pf-prix');
    if (!grille || !bloc) return;
    const perso = bloc.classList.contains('pf-prix--perso');
    let un = bloc.querySelector('.pf-prix__un');
    let qte = bloc.querySelector('.pf-prix__qte');
    if (!un) { un = document.createElement('p'); un.className = 'pf-prix__un'; bloc.prepend(un); }
    if (!qte) { qte = document.createElement('p'); qte.className = 'pf-prix__qte'; un.after(qte); }
    // Prix « dès » (coloris le moins cher, accueil et collections) : rappelé si la couleur choisie coûte plus. Inconnu hors liste.
    const mini = perso ? (un.querySelector('strong')?.textContent.trim() || '') : '';
    if (!perso) { bloc.classList.add('pf-prix--perso'); un.style.visibility = 'hidden'; }
    const euros = (p) => parseFloat(p.replace(/[^0-9,]/g, '').replace(',', '.')) || 0;
    const sticky = document.querySelector('.pp-sticky__txt span');
    const maj = () => {
      const prix = [...grille.querySelectorAll('.pp-cta__grille-row > div strong')].map((e) => e.textContent.trim()).filter((p) => /€/.test(p));
      if (!prix.length) return;
      un.style.visibility = '';
      // Critique design 16/10 : prix de la couleur + tableau ; plus de ligne « dès 51 pièces ». Le « dès » reprend le libellé des cartes.
      // Libellé unique, comme les cartes (lot 22) : « Dès 20 € » en grand, puis le prix de la couleur choisie en petit.
      const champ = [...document.querySelectorAll('.variant-picker fieldset')].find((f) => /couleur|color|coloris/i.test(f.querySelector('legend')?.textContent || ''));
      const couleur = champ?.querySelector('input:checked')?.value || '';
      // Charte v2 (lot 28) : le prix de la couleur choisie en étiquette, et le « dès » rappelé dessous seulement s'il est différent.
      const esc = (t) => t.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      un.innerHTML = '<span class="ptx-tag pf-prix__tag">' + esc(prix[0]) + '</span>';
      if (sticky) sticky.textContent = ptxT('Impression incluse, 1 pièce') + ' ' + prix[0];
      if (qte) qte.innerHTML = '<strong>' + (couleur ? esc(couleur) + ', ' : '') + ptxT('1 pièce, impression comprise.') + '</strong>' + (mini && mini !== prix[0] ? ' ' + fmt('Dès {prix} selon le coloris.', { prix: esc(mini) }) : '');
    };
    maj();
    new MutationObserver(maj).observe(grille, { childList: true, subtree: true });
  }

  // Charte v2 (lot 28) : sur mobile, un compteur « 1 / 15 » sur la photo remplace la rangée de points (masquée en CSS).
  function compteur() {
    const liste = document.querySelector('.product__media-list'); if (!liste) return;
    const points = document.querySelectorAll('.product__thumbnails.with-dots button, .product__thumbnails.with-dots .dot').length;
    const n = points || liste.querySelectorAll(':scope > .product__media').length; if (n < 2) return;
    const boite = liste.closest('slider-element, .product__media-wrapper') || liste.parentElement;
    const c = document.createElement('span'); c.className = 'pf-compteur'; c.setAttribute('aria-hidden', 'true'); boite.style.position = boite.style.position || 'relative'; boite.appendChild(c);
    const maj = () => { const w = liste.clientWidth || 1; c.textContent = Math.min(n, Math.round(liste.scrollLeft / w) + 1) + ' / ' + n; };
    liste.addEventListener('scroll', () => requestAnimationFrame(maj), { passive: true }); maj();
  }
  // Carte cadeau v2 (lot 28) : montants en grille, le montant en gros et « par ex. … » dessous (l'exemple n'est qu'un exemple).
  function montants() {
    const labels = [...document.querySelectorAll('input[name="Cadeau"] + label')]; if (!labels.length) return;
    labels.forEach((l) => {
      const t = l.textContent.trim(); const i = t.lastIndexOf(' – '); if (i < 0 || l.querySelector('.pf-montant')) return;
      const ex = t.slice(0, i).replace(/^Un /, '1 ').replace(' personnalisé', '');
      l.innerHTML = '<b class="pf-montant"></b><small class="pf-exemple"></small>'; l.querySelector('b').textContent = t.slice(i + 3); l.querySelector('small').textContent = ptxT('par ex.') + ' ' + ex;
    });
    const ul = labels[0].closest('ul'); if (ul) ul.classList.add('pf-montants');
    // Libellé visible du thème (« Cadeau : … ») remplacé par « Montant, utilisable sur tout le site » ; l'original reste dans la page (masqué) pour le script du thème.
    const lab = ul && ul.previousElementSibling;
    if (lab && lab.classList.contains('form__label') && !lab.querySelector('.pf-montants__titre')) { lab.classList.add('pf-montants__lab'); const t = document.createElement('p'); t.className = 'pf-montants__titre'; t.innerHTML = '<b>' + ptxT('Montant') + '</b> <span>' + ptxT('utilisable sur tout le site') + '</span>'; lab.prepend(t); }
  }
  const init = () => { couleurs(); vierge(); livraison(); prixHaut(); compteur(); montants(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', livraison);
})();
